import { render, staticRenderFns } from "./SocialUnit.vue?vue&type=template&id=0bf8eaaa&scoped=true"
import script from "./SocialUnit.vue?vue&type=script&lang=js"
export * from "./SocialUnit.vue?vue&type=script&lang=js"
import style0 from "./SocialUnit.vue?vue&type=style&index=0&id=0bf8eaaa&prod&lang=css"
import style1 from "./SocialUnit.vue?vue&type=style&index=1&id=0bf8eaaa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8eaaa",
  null
  
)

export default component.exports